interface CreditItem {
    name: string;
    role: string;
}

interface CreditsData {
    title: string;
    subtitle: string;
    credits: CreditItem[];
    specialThanks: {
        heading: string;
        entries: string[];
        footer: string;
    };
}
export const CreditsJsonData: CreditsData = {
    'title': 'CreditsTitle',
    'subtitle': 'CreditsRobotInvader',
    'credits': [
        {
            'name': 'CaseyRichardson',
            'role': 'CreditsGameDirector',
        },
        {
            'name': 'ChrisPruett',
            'role': 'CreditsEngineering',
        },
        {
            'name': 'MikeWitt',
            'role': 'CreditsArt',
        },
        {
            'name': 'JonnyRussell',
            'role': 'CreditsTechDesign',
        },
        {
            'name': 'MikeMcCool',
            'role': 'CreditsEngineering',
        },
        {
            'name': 'JordanFehr',
            'role': 'CreditsAudio',
        },
        {
            'name': 'JoshWhelchel',
            'role': 'CreditsMusic',
        },
        {
            'name': 'JustinQuan',
            'role': 'CreditsEngSupport',
        },
        {
            'name': 'Translator',
            'role': 'CreditsTranslation',
        },
        {
            'name': 'JapaneseTranslator',
            'role': 'CreditsJapanese',
        },
        {
            'name': 'Timmy Kokke',
            'role': 'Lead Engineer Web Port',
        },
        {
            'name': 'Nithin Steven F',
            'role': 'Engineer Web Port',
        },
    ],
    'specialThanks': {
        'heading': 'CreditsSpecialThanks',
        'entries': [
            'BertrandAmar',
            'EdAnnunziata',
            'NissaCampbell',
            'MikeChan',
            'MikeComfoltey',
            'HaroldDeArmas',
            'TaraLong',
            'GauravMathur',
            'GenkiMine',
            'TomMoss',
            'StathisMytilinaios',
            'VincentRenaud',
        ],
        'footer': 'CreditsThanksForPlaying',
    },
};
